module.exports = __webpack_public_path__ + "media/bootstrap-icons/mouse2-fill-296c7eb8.svg";